/* eslint-disable max-len */
export default {
  en: {
    commit: {
      compare: {
        title: 'Compare commits',
        text: 'Compare',
        with: 'compare with',
        none: 'Nothing to compare',
        choose: 'Choose commits to compare',
        noDiffs: 'No differences found',
        noDiffsWith: 'no differences with',
        options: 'Tag / Commit hash'
      },
      all: {
        title: 'All commits'
      },
      gpg: {
        title: 'GPG verification',
        verified: 'Verified',
        unverified: 'Unverified',
        expired: 'Expired',
        status: 'Status',
        reason: {
          title: 'Reason',
          noPublicKeyFound: 'No public key found',
          keyExpired: 'Signature key expired',
          commiterSignaatureEmailsNotMatch: "Committer's email does not match the signature email",
          other: 'Other reason'
        },
        id: 'Key ID'
      },
      tag: {
        create: 'Create tag'
      },
      pipeline: {
        start: 'Start pipeline'
      },
      files: {
        changed: 'Files changed'
      },
      author: 'Author',
      commiter: 'Committer',
      parents: 'Parents',
      cherryPick: {
        description:
          'The cherry-pick command allows selecting specific commits from one branch and applying them to another.',
        pickInto: 'Apply to branch',
        startMergeRequest: 'Create a merge request with these changes',
        newBranchName: 'New branch name',
        pick: 'Apply',
        hasConflicts: 'Unable to cherry-pick due to conflicts'
      },
      revert: {
        submit: 'Revert commit',
        cancel: 'Close',
        revertCommitDescription:
          "This action will create a new commit that reverts the existing changes (similar to 'git revert')",
        selectedTargetBranchTitle: 'The commit will be reverted in the branch:',
        revertAndCreateNewMergeRequestTitle: 'Create a separate merge request for the revert',
        createNewBranchForRevert: 'Create new branch for revert',
        revertCommitNote: 'Note: You can only revert a commit with one parent commit.',
        selectSourceBranchTitle: 'New branch name',
        error: 'An error occurred',
        no_permission: 'No permission to stop commit in protected branch'
      }
    }
  },
  ru: {
    commit: {
      compare: {
        title: 'Сравнение коммитов',
        text: 'Сравнить',
        with: 'сравнить с',
        none: 'Нечего сравнивать',
        choose: 'Выберите коммиты для сравнения',
        noDiffs: 'Различий не найдено',
        noDiffsWith: 'нет различий с',
        options: 'Тег / Хэш коммита'
      },
      all: {
        title: 'Все коммиты'
      },
      gpg: {
        title: 'GPG верификация',
        verified: 'Верифицирован',
        unverified: 'Неверифицирован',
        expired: 'Истек',
        status: 'Статус',
        reason: {
          title: 'Причина',
          noPublicKeyFound: 'Не найден публичный ключ',
          keyExpired: 'Ключ подписи просрочен',
          commiterSignaatureEmailsNotMatch:
            'Адрес почты коммитера не соответствует адресу почты подписи',
          other: 'Другая причина'
        },
        id: 'ID ключа'
      },
      tag: {
        create: 'Создать тег'
      },
      pipeline: {
        start: 'Запустить конвейер'
      },
      files: {
        changed: 'Файлов изменено'
      },
      author: 'Автор',
      commiter: 'Коммитер',
      parents: 'Родители',
      cherryPick: {
        description:
          'Команда cherry-pick позволяет выбрать отдельные коммиты из одной ветки и применить их к другой.',
        pickInto: 'Выполнить в ветку',
        startMergeRequest: 'Создать запрос на слияние с этими изменениями',
        newBranchName: 'Название новой ветки',
        pick: 'Выполнить',
        hasConflicts: 'Невозможно выполнить команду cherry-pick, так как присутствуют конфликты'
      },
      revert: {
        submit: 'Отменить коммит',
        cancel: 'Закрыть',
        revertCommitDescription:
          'Это действие создаст новый коммит, который отменит существующие изменения (аналогично "git revert")',
        selectedTargetBranchTitle: 'Коммит будет отменен в ветке:',
        revertAndCreateNewMergeRequestTitle: 'Создать отдельный запрос на слияние для отмены',
        createNewBranchForRevert: 'Создать новую ветку для отмены',
        revertCommitNote: 'Примечание: Можно отменить коммит только с одним родительским коммитом',
        selectSourceBranchTitle: 'Название новой ветки',
        error: 'Произошла ошибка',
        no_permission: 'Нет прав для отмены коммита в защищенной ветке'
      }
    }
  }
};
